<template>
  <div ref="fundsHistoryTable" class="balance-history-stats-table-main">
    <div class="balance-history-stats-container">
      <div class="balance-history-stats-header">
        <div class="balance-history-stats-header-column">
          <h1>Referral History</h1>
          <p>An overview of your recent Referral history.</p>
        </div>
        <div
          @click="refresh"
          class="balance-history-stats-refresh"
          style="cursor: pointer"
        >
          REFRESH
        </div>
      </div>
      <div class="balance-history-stats-variants">
        <div @click="activatePublic">
          <p
            :class="
              allMoney ? 'balance-history-active' : 'balance-history-inactive'
            "
          >
            All
          </p>
          <div
            v-if="allMoney"
            class="balance-history-stats-active-variant"
          ></div>
        </div>
        <div @click="activatePrivate">
          <p
            :class="
              moneyIn ? 'balance-history-active' : 'balance-history-inactive'
            "
          >
            Add
          </p>
          <div
            v-if="moneyIn"
            class="balance-history-stats-active-variant"
          ></div>
        </div>
        <div @click="activateFactory">
          <p
            :class="
              moneyOut ? 'balance-history-active' : 'balance-history-inactive'
            "
          >
            Subtract
          </p>
          <div
            v-if="moneyOut"
            class="balance-history-stats-active-variant"
          ></div>
        </div>
      </div>
      <div class="balance-history-item-header">
        <div class="balance-history-item-index">#</div>
        <div class="balance-history-item-time">Time</div>
        <div class="balance-history-item-type">
          Action
        </div>
        <div class="balance-history-item-desc">
          Description
        </div>
        <div class="balance-history-item-amount">
          Initial Balance
        </div>
        <div class="balance-history-item-amount">
          Final Balance
        </div>
      </div>
      <div v-if="allMoney" class="balance-history-stats-actual-graphs">
        <div v-if="moneyAllList.length > 0">
          <div
            class="balance-history-item"
            v-for="(record, key) in moneyAllList"
            :key="key"
          >
            <div class="balance-history-item-index">{{ key + 1 }}</div>
            <div class="balance-history-item-time">{{ record.createdAt }}</div>
            <div class="balance-history-item-type">
              {{ record.balanceAction }}
            </div>
            <div class="balance-history-item-desc">
              {{ record.description }}
            </div>
            <div class="balance-history-item-amount">
              ${{ parseFloat(record.initialBalance / 100).toFixed(4) }}
            </div>
            <div class="balance-history-item-amount">
              ${{ parseFloat(record.finalBalance / 100).toFixed(4) }}
            </div>
          </div>
          <div v-if="allLoaded" class="load-more">
            <p @click="updateAll">Load More</p>
          </div>
          <div v-else class="load-more">
            <PulseLoader color="#eddb51" />
          </div>
        </div>
        <div v-else class="no-transactions">
          <div v-if="allLoaded">No Transactions Found!</div>
          <div v-else class="load-more">
            <PulseLoader color="#eddb51" />
          </div>
        </div>
      </div>
      <div v-if="moneyIn" class="balance-history-stats-actual-graphs">
        <div v-if="moneyInList.length > 0">
          <div
            class="balance-history-item"
            v-for="(record, key) in moneyInList"
            :key="key"
          >
            <div class="balance-history-item-index">{{ key + 1 }}</div>
            <div class="balance-history-item-time">{{ record.createdAt }}</div>
            <div class="balance-history-item-type">
              {{ record.balanceAction }}
            </div>
            <div class="balance-history-item-desc">
              {{ record.description }}
            </div>
            <div class="balance-history-item-amount">
              ${{ parseFloat(record.initialBalance / 100).toFixed(4) }}
            </div>
            <div class="balance-history-item-amount">
              ${{ parseFloat(record.finalBalance / 100).toFixed(4) }}
            </div>
          </div>
          <div v-if="inLoaded" class="load-more">
            <p @click="updateIn">Load More</p>
          </div>
          <div v-else class="load-more">
            <PulseLoader color="#eddb51" />
          </div>
        </div>
        <div v-else class="no-transactions">
          <div v-if="inLoaded">No Transactions Found!</div>
          <div v-else class="load-more">
            <PulseLoader color="#eddb51" />
          </div>
        </div>
      </div>
      <div v-if="moneyOut" class="balance-history-stats-actual-graphs">
        <div v-if="moneyOutList.length > 0">
          <div
            class="balance-history-item"
            v-for="(record, key) in moneyOutList"
            :key="key"
          >
            <div class="balance-history-item-index">{{ key + 1 }}</div>
            <div class="balance-history-item-time">{{ record.createdAt }}</div>
            <div class="balance-history-item-type">
              {{ record.balanceAction }}
            </div>
            <div class="balance-history-item-desc">
              {{ record.description }}
            </div>
            <div class="balance-history-item-amount">
              ${{ parseFloat(record.initialBalance / 100).toFixed(4) }}
            </div>
            <div class="balance-history-item-amount">
              ${{ parseFloat(record.finalBalance / 100).toFixed(4) }}
            </div>
          </div>
          <div v-if="outLoaded" class="load-more">
            <p @click="updateOut">Load More</p>
          </div>
          <div v-else class="load-more">
            <PulseLoader color="#eddb51" />
          </div>
        </div>
        <div v-else class="no-transactions">
          <div v-if="outLoaded">No Transactions Found!</div>
          <div v-else class="load-more">
            <PulseLoader color="#eddb51" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { handleGetReferralTableHistory } from "../../../service/referral";
export default {
  components: {
    PulseLoader,
  },
  data: () => {
    return {
      allMoney: true,
      moneyIn: false,
      moneyOut: false,
      moneyInList: [],
      moneyOutList: [],
      moneyAllList: [],
      inLoaded: false,
      outLoaded: false,
      allLoaded: false,
      inPage: 1,
      outPage: 1,
      allPage: 1,
      limit: 8,
    };
  },
  async mounted() {
    await this.sleep(10);
    this.$refs.fundsHistoryTable.style = "transform: scale(1) !important";
    const moneyInData = await handleGetReferralTableHistory(
      "Add",
      this.inPage,
      this.limit
    );
    this.moneyInList = moneyInData.data.data.results;
    this.inLoaded = true;
    const moneyAllData = await handleGetReferralTableHistory(
      "All",
      this.allPage,
      this.limit
    );
    this.moneyAllList = moneyAllData.data.data.results;

    this.allLoaded = true;
    const moneyOutData = await handleGetReferralTableHistory(
      "Subtract",
      this.outPage,
      this.limit
    );
    this.moneyOutList = moneyOutData.data.data.results;
    this.outLoaded = true;
  },

  methods: {
    async refresh() {
      this.inLoaded = false;
      this.allLoaded = false;
      this.outLoaded = false;
      this.moneyAllList = [];
      this.moneyInList = [];
      this.moneyOutList = [];

      const moneyInData = await handleGetReferralTableHistory(
        "Add",
        this.inPage,
        this.limit
      );
      this.moneyInList = moneyInData.data.data.results;
      this.inLoaded = true;
      const moneyAllData = await handleGetReferralTableHistory(
        "All",
        this.allPage,
        this.limit
      );
      this.moneyAllList = moneyAllData.data.data.results;
      this.allLoaded = true;
      const moneyOutData = await handleGetReferralTableHistory(
        "Subtract",
        this.outPage,
        this.limit
      );
      this.moneyOutList = moneyOutData.data.data.results;
      this.outLoaded = true;
    },
    activatePublic() {
      this.allMoney = true;
      this.moneyIn = false;
      this.moneyOut = false;
    },
    async activatePrivate() {
      this.allMoney = false;
      this.moneyIn = true;
      this.moneyOut = false;
    },
    activateFactory() {
      this.allMoney = false;
      this.moneyIn = false;
      this.moneyOut = true;
    },
    async updateOut() {
      this.outPage++;
      this.outLoaded = false;
      const moneyOutData = await handleGetReferralTableHistory(
        "Subtract",
        this.outPage,
        this.limit
      );
      this.moneyOutList = [
        ...this.moneyOutList,
        ...moneyOutData.data.data.results,
      ];
      this.outLoaded = true;
    },
    async updateIn() {
      this.inPage++;
      this.inLoaded = false;
      const moneyInData = await handleGetReferralTableHistory(
        "Add",
        this.inPage,
        this.limit
      );
      this.moneyInList = [
        ...this.moneyInList,
        ...moneyInData.data.data.results,
      ];
      this.inLoaded = true;
    },
    async updateAll() {
      this.allPage++;
      this.allLoaded = false;
      const moneyAllData = await handleGetReferralTableHistory(
        "All",
        this.allPage,
        this.limit
      );
      this.moneyAllList = [
        ...this.moneyAllList,
        ...moneyAllData.data.data.results,
      ];
      this.allLoaded = true;
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
  },
};
</script>

<style scoped>
.no-transactions {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  height: 100%;
}
.load-more {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.load-more > p {
  cursor: pointer;
}
.balance-history-stats-table-main {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 30px;
  height: 750px;
  background: radial-gradient(
    100% 100% at 44.04% 0%,
    #26292e85 0%,
    #1a1c1f 100%
  );
  mix-blend-mode: normal;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.0835883), inset 0px 1px 3px #000000;
  border-radius: 7px;
  transform: scale(0.5);
  transition: 0.4s;
}

.balance-history-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 95%;
  /* min-width: 680px; */
  /* box-shadow: 2px 2px 10px #000000; */
  margin: auto;

  mix-blend-mode: normal;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.0835883);
  border-radius: 10px;
  margin-top: 20px;
  height: 45px;
  color: #888888;
  background: radial-gradient(
    100% 100% at 44.04% 0%,
    rgba(38, 41, 46, 0.5) 0%,
    #1a1c1f 100%
  );
  padding-left: 20px;
}

.balance-history-item-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 95%;
  margin: auto;
  padding-left: 20px;
  height: 45px;
  margin-top: 8px;
}

.balance-history-item-header > div {
  color: #888888;
  font-family: "OpenSans-Bold";
  font-size: 16px;
}

.balance-history-item-index {
  flex: 0.1;
  font-size: 12px;
}

.balance-history-item-time {
  flex: 0.3;
  font-size: 12px;
}

.balance-history-item-desc {
  flex: 0.5;
  font-size: 12px;
  justify-content: center;
  display: flex;
}

.balance-history-item-type {
  flex: 0.1;
  font-size: 12px;
}
.balance-history-item-amount {
  flex: 0.25;
  font-size: 12px;
  display: flex;
}

.balance-history-item-amount:nth-child(1) {
  justify-content: flex-start;
}

.balance-history-item-amount:nth-child(2) {
  justify-content: center;
}

.balance-history-stats-container {
  height: 100%;
  width: 95%;
  margin: auto;
  margin-top: 24px;
}
.balance-history-stats-header {
  display: flex;
  justify-content: space-between;
}

.balance-history-stats-header-column {
  display: flex;
  flex-direction: column;
}
.balance-history-stats-header-column > h1 {
  color: #e0e0e0;
  font-size: 20px;
  font-family: "OpenSans-SemiBold";
}

.balance-history-stats-header-column > p {
  color: #888888;
  margin-top: 4px;
}
.balance-history-stats-refresh {
  color: #888888;
  font-size: 10px;
}

.balance-history-stats-actual-graphs {
  background-color: #131517;
  height: 550px;
  width: 100%;
  border-radius: 10px;
  align-items: center;
  margin: auto;
  overflow-y: auto;
}
.balance-history-stats-variants {
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 24px;
}
.balance-history-stats-variants > div {
  margin-left: 20px;
  margin-right: 20px;
  text-align: center;
  cursor: pointer;
}
.balance-history-stats-active-variant {
  width: 65px;
  height: 2px;
  background-color: #eddb51;
}
.balance-history-active {
  color: #ffffff !important;
  font-family: "OpenSans-SemiBold";
  font-size: 12px;
  text-align: center !important;
}
.balance-history-inactive {
  color: #888888;
  font-size: 12px;
  text-align: center !important;
  width: 65px;
}
.balance-history-stats-actual-graphs-row {
  display: flex;
  width: 100%;
  justify-content: space-evenly;
  margin-top: 24px;
}
</style>
